const translation = {
  daysInWeek: {
    Wed: '수요일',
    Thu: '목요일',
    Fri: '자유',
    Sat: '토요일',
    Sun: '태양',
    Tue: '화요일',
    Mon: '몬',
  },
  months: {
    May: '5 월',
    January: '1 월',
    August: '8 월',
    July: '7 월',
    April: '4 월',
    October: '10 월',
    December: '12 월',
    February: '2 월',
    June: '6 월',
    November: '11 월',
    March: '3 월',
    September: '9 월',
  },
  operation: {
    pickDate: '날짜 선택',
    cancel: '취소',
    ok: '좋아요',
    now: '지금',
  },
  title: {
    pickTime: '시간 선택',
  },
  defaultPlaceholder: '시간을 선택하세요...',
}

export default translation
